import _extends from "@babel/runtime/helpers/extends";

/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../internal'; // eslint-disable-next-line react/display-name

var IconComponent = React.forwardRef(function (props, ref) {
  return React.createElement("svg", _extends({}, props, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), React.createElement("g", {
    id: "16x16/vas_color"
  }, React.createElement("g", {
    id: "Subtract"
  }, React.createElement("path", {
    d: "M9.50574 2.84833L7.65741 1L4.57641 4.08099L11.9708 11.4754L15.0518 8.39438L10.7575 4.10006L9.53506 5.32247C9.18941 5.66812 8.62899 5.66812 8.28333 5.32247C7.93768 4.97681 7.93768 4.41639 8.28333 4.07074L9.50574 2.84833Z",
    fill: "currentColor"
  }), React.createElement("path", {
    d: "M10.7383 12.7082L3.34391 5.31382L2.89491 5.76282C2.12194 6.53579 2.12194 7.78903 2.89491 8.562L4.25761 9.92471L1.75994 11.7088C0.847494 12.3605 0.738655 13.6756 1.53154 14.4685C2.32442 15.2613 3.63949 15.1525 4.29124 14.2401L6.07529 11.7424L7.49011 13.1572C8.26308 13.9302 9.51632 13.9302 10.2893 13.1572L10.7383 12.7082Z",
    fill: "currentColor"
  }))));
});
/**
 * Компоненты иконки <br />
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.<br />
 * Подключение иконки: `import { VasColor16 } from '@cian/ui-kit/icons';`, <br />
 * где 16 - это размер иконки в пикселях.
 */

export var VasColor16 = createIcon(IconComponent);